import { render, staticRenderFns } from "./BuyerProjects.vue?vue&type=template&id=b1209e70"
import script from "./BuyerProjects.vue?vue&type=script&lang=js"
export * from "./BuyerProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports